module.exports = __webpack_public_path__ + "img/Boy_020035.dcc86c49.png";